import {ColorBadge} from "@/shared/ui/ColorBadge";
import {FilterOption} from "@/features/catalog-filters";

type Props = {
    option: FilterOption;
    insertColors: Record<string, string>;
};

export const CatalogFilterOptionLabel = (
    {
        option,
        insertColors = {},
    }: Props
) => {
    const isInsertColor = option.key === "insertsColor";

    const color = insertColors[option.value];

    return (
        <>
            {isInsertColor && (
                <ColorBadge
                    color={color}
                    empty={option.value === "Бесцветный"}
                    bordered={option.value === "Белый"}
                />
            )}
            {option.value}
        </>
    );
};
